import A11yDialog from 'a11y-dialog';
import {detectMobile, setHeightToVh, toggleDialogState, debounceEvent, detectMobileUntilTablet} from '../../../js/utils';

export default class SwaDialogOverlay {
  constructor(dialogElement) {
    this.dialogId = dialogElement.getAttribute('id');
    this.dialogElement = dialogElement;
    this.dialogContent = dialogElement.querySelector('.swa-dialog-content');
  }

  init() {
    const overlayDialogIdSelector = `#${this.dialogId}`;
    const overlayDialogElement = document.querySelector(overlayDialogIdSelector);
    const styleOverlay = { open: 'swa-dialog-open'};
    const centeredDialog = document.querySelector(`#${this.dialogId} .swa-dialog-content-center-overlay .swa-dialog-content`);
    const centerDialogOverlay =  document.querySelector(`#${this.dialogId} .js-swa-dialog-content-center-overlay .swa-dialog-overlay`);

    if (!overlayDialogElement) {
      return;
    }

    if(!window.overlayMessageDialogs) {
      window.overlayMessageDialogs = {};
    }
    // Instantiate a new A11yDialog module
    let dialogInstance = new A11yDialog(overlayDialogElement);
    window.overlayMessageDialogs[this.dialogId] = dialogInstance;

    let bodyElement = document.querySelector('body');

    dialogInstance.on('show', () => {
      setHeightToVh();//Because there are browsers which do not support vh measure for height calculation, we have to calculate it manually, for the dialog to fit the screen
      toggleDialogState(this.dialogId, true);

      // Prevent layout shift on all viewports due to scrollbar dissapearing when overlay is present
      if (!this.dialogElement.classList.contains("swa-sorting__dialog")) {
        bodyElement.classList.add('swa-no-scroll');
        bodyElement.classList.add('swa-no-scroll-with-scrollbar');
      }

      // Keep body scroll when cookie consent is opened
      if (this.dialogElement.classList.contains('swa-dialog--cookie-consent') && bodyElement.classList.contains('swa-no-scroll')) {
        bodyElement.classList.remove('swa-no-scroll');
        bodyElement.classList.remove('swa-no-scroll-with-scrollbar');
      }

      // Prevent DialogCenter from closing when clicking on the grey overlay
      if (centerDialogOverlay) {
        centerDialogOverlay.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
        }, true);
      }

      // When user is on tablet mode and does resizing, apply necessary classes to fit content and also to stop scrolling outside the modal (mainly happening on iOS Safari)
      window.visualViewport.addEventListener('resize', debounceEvent((event) => {
        if(detectMobileUntilTablet()) {
          return;
        }
        if(this.dialogContent.classList.contains('swa-dialog--right-side') && this.dialogContent.querySelector('.js-configurable-form')) {
          if(event.target.height != window.innerHeight) {
            bodyElement.classList.add('swa-no-scroll-with-scrollbar');
            this.dialogContent.style.overflow = 'hidden';
          } else {
            bodyElement.classList.remove('swa-no-scroll-with-scrollbar')
            this.dialogContent.removeAttribute('style');
          }
        }
      }, 100));

      // This is just for patternlab, since the dialogs content comes later in Hybris
      if (document.querySelector('.js-patternlab-page') && centeredDialog) {
        // Used for dialog component, for calculating whether or not the height of the dialog is higher than the viewport height,in order to center or not the dialog.
        if (detectMobile()) {
          let dialogHeight = centeredDialog.offsetHeight + 140; //140 represents the margins of the dialog, which need to taken into consideration as well.
          if (window.innerHeight > dialogHeight) {
            centeredDialog.classList.add('swa-dialog-content-center--mobile');
          }
        }
      }
    });

    dialogInstance.on('hide', () => {
      toggleDialogState(this.dialogId, false);
      bodyElement.classList.remove('swa-no-scroll');
      bodyElement.classList.remove('swa-no-scroll-with-scrollbar');
    });
  }
}
